import React from 'react'
import { MemberQuoteAddFeature } from 'features/member/member-quote/member-quote-add/member-quote-add.feature'

export default function MemberQuoteAddPage() {
  return <MemberQuoteAddFeature />
}
